/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EnumChatActivityStatus = "assigned" | "closed" | "pending" | "unassigned" | "%future added value";
export type IconButtonPatientActions_Patient = {
    readonly _id: string;
    readonly chatActivity?: {
        readonly _id: string;
        readonly status: EnumChatActivityStatus | null;
        readonly assignee: {
            readonly _id: string;
        } | null;
        readonly groupAssignee: {
            readonly _id: string;
        } | null;
    } | null | undefined;
    readonly " $refType": "IconButtonPatientActions_Patient";
};
export type IconButtonPatientActions_Patient$data = IconButtonPatientActions_Patient;
export type IconButtonPatientActions_Patient$key = {
    readonly " $data"?: IconButtonPatientActions_Patient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"IconButtonPatientActions_Patient">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "includeChatActivity"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "IconButtonPatientActions_Patient",
  "selections": [
    (v0/*: any*/),
    {
      "condition": "includeChatActivity",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ChatActivity",
          "kind": "LinkedField",
          "name": "chatActivity",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "assignee",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Group",
              "kind": "LinkedField",
              "name": "groupAssignee",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
})();
(node as any).hash = '6331956750e2e68fc3bd4dd730eaa88d';
export default node;
